import type { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import type { UseQueryResult } from 'react-query/types/react/types';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const GET_PROFILE_COMPLETION_KEY = 'getProfileCompletionKey';

export interface IProfileCompletionResponse {
  result: number;
}

export const useGetProfileCompletion = (): UseQueryResult<
  IProfileCompletionResponse['result'],
  AxiosError
> => {
  const queryFn = async (): Promise<IProfileCompletionResponse['result']> => {
    const { data } = await axios.get<IProfileCompletionResponse>(
      Routes.users_profile_completion_path(),
    );

    return data?.result;
  };

  return useQuery({
    queryKey: [GET_PROFILE_COMPLETION_KEY],
    queryFn,
  });
};
